const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Backend's Image::fields() returns full_path that already resolves
// S3 vs filesystem based on the record's `storage` column. Prefer it.
// Fallback covers legacy responses where full_path is missing.
export const getImageUrl = (image, fallback = '') => {
  if (!image) return fallback;
  if (image.full_path) return image.full_path;
  if (!image.path) return fallback;
  const path = image.path.startsWith('/') ? image.path : '/' + image.path;
  return API_BASE_URL + path;
};
